'use client';

import { InverseHeader, RadialGradientBG } from '@jouzen/ecom-components';

import landingPageBodyGradients from '@/app/components/LandingPage/_data/landingPageBodyGradients/landingPageBodyGradients';
import FooterMultivariatePaymentOptions from '@/app/components/MultivariatePaymentOptions/FooterMultivariatePaymentOptions';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import StressBlog from './_components/StressBlog/StressBlog';
import StressFeatures from './_components/StressFeatures/StressFeatures';
import StressHero from './_components/StressHero/StressHero';
import StressIntegrations from './_components/StressIntegrations/StressIntegrations';
import StressJumbotron from './_components/StressJumbotron/StressJumbotron';
import StressTestimonials from './_components/StressTestimonials/StressTesimonials';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="stress-page">
      <InverseHeader exit>
        <StressHero />
        <RadialGradientBG
          background="sandstone-200"
          className="overflow-hidden"
          gradients={landingPageBodyGradients}
        >
          <div className="relative">
            <StressFeatures />
            <StressJumbotron />
            <StressTestimonials />
            <StressIntegrations />
          </div>
        </RadialGradientBG>
      </InverseHeader>
      <InverseHeader enter>
        <StressBlog />
        <FooterMultivariatePaymentOptions className="bg-purple-600 pb-16" />
      </InverseHeader>
    </div>
  );
};

export default Content;
